import { useReducer, useState } from 'react';
import { PartsFilters } from './inventoryTypes';
import InventoryPartsOptionsBar from './InventoryPartsOptionsBar';
import { Item } from '../../utils/sharedTypes';
import InventoryPartsFilterBar from './InventoryPartsFilterBar';
import InventoryPartsTable from './InventoryPartsTable';

const filtersInitialState: PartsFilters = {
  searchTerms: '',
  toAmountFilter: '',
  fromAmountFilter: '',
};

const InventoryParts = () => {
  const [filters, setFilters] = useReducer(
    (curVals: PartsFilters, newVals: any) => ({ ...curVals, ...newVals }),
    filtersInitialState
  );
  const [selectedParts, setSelectedParts] = useState<Item[]>([]);
  const [editModalOpenFlag, setEditModalOpenFlag] = useState<boolean>(false);
  return (
    <>
      <InventoryPartsFilterBar
        filters={filters}
        setFilters={setFilters}
        initialFilters={filtersInitialState}
      />
      <InventoryPartsOptionsBar
        selectedParts={selectedParts}
        setSelectedParts={setSelectedParts}
        editModalOpenFlag={editModalOpenFlag}
        setEditModalOpenFlag={setEditModalOpenFlag}
      />
      <InventoryPartsTable
        setSelectedParts={setSelectedParts}
        filters={filters}
        setEditModalOpenFlag={setEditModalOpenFlag}
      />
    </>
  );
};

export default InventoryParts;
